import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dataFetched ? _c('div', {
    staticClass: "card-form container"
  }, [_c('b-row', {
    staticClass: "mb-5 w-100 d-flex justify-content-around",
    style: _vm.cardStyle
  }, [_c('img', {
    staticClass: "max-h-80px",
    attrs: {
      "alt": "Logo",
      "src": _vm.emissor.logo
    }
  }), _c('div', {
    staticClass: "mt-5",
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.emissor.nome) + " - " + _vm._s(_vm.emissor.telefone))]), _vm._v(" "), _c('br'), _vm.emissor.cnpj_cpf.length < 14 ? _c('span', [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(_vm.emissor.cnpj_cpf)))]) : _vm._e(), _vm.emissor.cnpj_cpf.length >= 14 ? _c('span', [_vm._v("CNPJ: " + _vm._s(_vm.formatCpfCnpj(_vm.emissor.cnpj_cpf)))]) : _vm._e(), _c('br'), _c('span', [_vm._v(_vm._s("".concat(_vm.emissor.logradouro, " - ").concat(_vm.emissor.numero, " - ").concat(_vm.emissor.bairro, ", ").concat(_vm.emissor.cep)))]), _c('br'), _c('span', [_vm._v(_vm._s("".concat(_vm.emissor.cidade, " - ").concat(_vm.emissor.uf)))]), _c('br')])]), _c('strong', [_vm._v("Pedido: ")]), _c('span', [_vm._v(" " + _vm._s(_vm.numero) + " ")]), _c('div', [_c('div', [_c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Cliente",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Nome: ")]), _vm._v(_vm._s(_vm.cliente.nome)), _c('br'), _vm.cliente.cnpj_cpf !== null && _vm.cliente.cnpj_cpf.length < 14 ? _c('strong', [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(_vm.cliente.cnpj_cpf)) + " "), _c('br')]) : _vm._e(), _vm.cliente.cnpj_cpf !== null && _vm.cliente.cnpj_cpf.length >= 14 ? _c('strong', [_vm._v("CNPJ: " + _vm._s(_vm.formatCpfCnpj(_vm.cliente.cnpj_cpf))), _c('br')]) : _vm._e(), _vm.cliente.telefone ? _c('strong', [_vm._v("Telefone:")]) : _vm._e(), _vm._v(_vm._s(_vm.cliente.telefone)), _c('br'), _vm.cliente.cep ? _c('div', {
    staticStyle: {
      "white-space": "normal"
    }
  }, [_c('strong', [_vm._v("Endereço: ")]), _vm._v(" " + _vm._s(_vm.cliente.logradouro) + ", " + _vm._s(_vm.cliente.numero) + "," + _vm._s(_vm.cliente.bairro) + "," + _vm._s(_vm.cliente.complemento) + " " + _vm._s(_vm.cliente.cep) + "," + _vm._s(_vm.cliente.cidade) + "-" + _vm._s(_vm.cliente.uf) + " ")]) : _vm._e()])], 1), _c('b-card', {
    staticClass: "mb-2 border border-primary",
    attrs: {
      "title": "Produtos",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm.produtos.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "items": _vm.tableItems
    },
    scopedSlots: _vm._u([{
      key: "row-details",
      fn: function fn(row) {
        return [_vm.getProdutoObservacao(row) ? _c('b-row', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_c('b-col', [_vm._v("Observacao: " + _vm._s(_vm.getProdutoObservacao(row)) + " ")])], 1) : _vm._e()];
      }
    }], null, false, 1937749499)
  }) : _vm._e()], 1)], 1), _c('b-card', {
    staticClass: "mb-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Pagamentos",
      "tag": "article"
    }
  }, _vm._l(_vm.pagamentos, function (pagamento, index) {
    return _c('b-card-text', {
      key: pagamento.descricao
    }, [_c('label', [_vm._v(_vm._s(pagamento.paymentMode.name))]), _vm.produtos.length > 0 ? _c('b-table', {
      attrs: {
        "striped": "",
        "small": "",
        "fixed": "",
        "hover": "",
        "items": _vm.tablePagamentoItems(index)
      }
    }) : _vm._e()], 1);
  }), 1), _c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Outras informaçoes",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Vendedor: ")]), _vm._v(" " + _vm._s(_vm.vendedor) + " "), _c('br'), _c('strong', [_vm._v("Solicitante: ")]), _vm._v(" " + _vm._s(_vm.solicitante) + " "), _c('br'), _c('strong', [_vm._v("Observação: ")]), _vm._v(" " + _vm._s(_vm.observacao) + " "), _c('br'), _c('strong', [_vm._v("Dt. Validade: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.validade, "DD/MM/YYYY"))), _c('br'), _c('strong', [_vm._v("Dt. Solicitação: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.data_solicitacao, "DD/MM/YYYY")) + " "), _c('br'), _c('strong', [_vm._v("Desconto Geral R$: ")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.desconto, 2)) + " "), _c('br'), _c('strong', [_vm._v("Frete R$: ")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.frete, 2)) + " "), _c('br'), _c('strong', [_vm._v("Total pedido R$: ")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.valorTotal, 2)) + " ")])], 1), _vm.status != 1 && _vm.status != 7 && _vm.status != 2 && _vm.status != 6 && _vm.status != 9 && _vm.status != 10 ? _c('span', {
    class: _vm.statusClass(_vm.status),
    attrs: {
      "slot": "status"
    },
    slot: "status"
  }, [_vm._v(" " + _vm._s(_vm.statusLabel(_vm.status)) + ", por " + _vm._s(_vm.contatoResposta) + " : " + _vm._s(_vm._f("moment")(_vm.dataResposta, "DD/MM/YYYY HH:mm:ss")) + " ")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-end"
  }, [_c('img', {
    staticClass: "max-h-60px mr-5",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.secundary')
    }
  })])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };